import { create } from 'zustand';

export type SidebarSection = 'general' | 'relationships' | 'variables' | 'versions' | 'columns' | 'filters';

interface LinkedTableSidebarStore {
  activeSection: SidebarSection;
  setActiveSection: (section: SidebarSection) => void;
  /** Reset to default section (columns) */
  reset: () => void;
}

export const useLinkedTableSidebarStore = create<LinkedTableSidebarStore>()((set) => ({
  activeSection: 'columns',
  setActiveSection: (section) => set({ activeSection: section }),
  reset: () => set({ activeSection: 'columns' }),
}));
